<template>
    <fb-list-body :pager="pager"

                  @handlePagerSizeChange="handlePagerSizeChange"
                  @handlePagerIndexChange="handlePagerIndexChange"
    >

        <template slot="btn-group">
            <el-button icon="el-icon-delete" @click.native="handleBatchDelete">删除</el-button>
        </template>




        <template slot="search-form">
            <el-form-item class="search-form-item" label="设备id">
                <el-input v-model="searchForm.deviceId" placeholder="设备id"></el-input>
            </el-form-item>

            <el-button icon="el-icon-search" size="mini" @click.stop="handleSearch">查询</el-button>

        </template>

        <template slot="table">

            <div class="space-list">

                <div class="space-item">
                    {{count.today}} <br> <span class="label">本日活跃</span>
                </div>

                <div class="space-item">
                    {{count.day7}}<br> <span class="label">本周活跃</span>
                </div>

                <div class="space-item">
                    {{count.day30}}<br> <span class="label">本月活跃</span>
                </div>

            </div>

            <el-table :data="tableData"  @selection-change="handleSelectionChange">

                <el-table-column
                        type="selection"
                        width="50">
                </el-table-column>

                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>

                <el-table-column
                        prop="deviceId"
                        label="设备id"
                        >
                </el-table-column>

                <el-table-column
                        prop="useCount"
                        label="启动次数"
                >
                </el-table-column>

                <el-table-column
                        prop="lastActiveTimeStr"
                        label="上一次使用时间"
                >
                </el-table-column>

                <el-table-column
                        prop="lastActiveIp"
                        label="上一次使用ip"
                >
                </el-table-column>

                <el-table-column
                        prop="ipInfo"
                        label="地区"
                >
                </el-table-column>

                <el-table-column
                        prop="firstActiveTimeStr"
                        label="第一次使用时间"
                >
                </el-table-column>

                <el-table-column
                        fixed="right"
                        label="操作"
                       >
                    <template slot-scope="scope">

<!--                        <el-link type="primary" @click="handleEdit(scope.row)" :underline="false" >编辑</el-link>-->

                        <el-link type="danger"  @click="handleDelete(scope.row)" :underline="false" style="margin-left: 10px;">删除</el-link>
                    </template>
                </el-table-column>


            </el-table>
        </template>


    </fb-list-body>
</template>

<script>

    import CmsCategorySelect from "../../components/CmsCategorySelect";
    export default {
        name: "PartnerList",
        components: {CmsCategorySelect},
        props:{
          timestamp:{type:Number,default:function () {
                  return new Date().getTime()
              }},
        },
        data() {
            return {
                api:{
                    list:this.$api.deviceStat.list,
                    delete:this.$api.deviceStat.delete,
                    batchDelete:this.$api.deviceStat.batchDelete,
                },
                searchForm: {categoryFlag:'DOCUMENT'},
                tableData:[],
                selection:[],
                pager: {
                    pageSize: 10
                    , pageIndex: 1,
                    itemCount: 0
                },
                count:{
                    today:0,
                    day7:0,
                    day30:0
                }
            }
        },
        computed: {
            searchParams() {
                return Object.assign({}, this.$route.query,this.searchForm,this.pager);
            }
        },
        watch:{
            "$route.query":{
                handler() {
                    this.pageIndex=1;
                    this.handleSearch();
                },
                deep:true,
                immediate:true
            },
            "pager.pageIndex":{
                handler() {
                    this.handleSearch();

                },
                deep:true,
                immediate:true
            },
            "pager.pageSize":{
                handler() {
                    this.handleSearch();

                },
                deep:true
            }
        },
        methods: {

            handleEdit(e) {

                if(e && e.code){
                    this.$router.push({path:'edit',query:{code:e.code}});
                    return;
                }

                if(!this.selection.length){
                    this.$message({type:'warning',message:'未选择记录'});
                    return ;
                }

                if(this.selection.length > 1){
                    this.$message({type:'warning',message:'一次只能编辑一条数据'});
                    return ;
                }

                this.$router.push({path:'edit',query:{code:this.selection[0].code}});
            },
            handleDelete(row){


                let vm = this;

                vm.$confirm('您现在正在进行删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(vm.api.delete,vm.$qs.stringify({code:row.code})).then((resp)=>{
                        if(resp.data.status === 200){
                            vm.$message({type:'success',message:resp.data.desc});
                            vm.handleSearch();
                        }else{
                            vm.$message({type:'error',message:resp.data.desc});

                        }
                    })



                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });

            },
            handleBatchDelete() {


                let vm = this;

                if(!this.selection.length){
                    this.$message({type:'warning',message:'未选择记录'});
                    return ;
                }


                let codes = [];

                this.selection.forEach((e)=>{
                    codes.push(e.code);
                });


                this.$confirm('您现在正在进行批量删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(this.api.batchDelete,codes).then((resp)=>{
                        if(resp.data.status === 200){
                            vm.$message({type:'success',message:resp.data.desc});
                            vm.handleSearch();
                        }else{
                            vm.$message({type:'error',message:resp.data.desc});

                        }
                    })



                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });




            },
            handleSelectionChange(selection){
                console.log(selection);
                this.selection = selection;
            },
            handlePagerSizeChange(e){
                this.pager.pageSize = e;
            },
            handlePagerIndexChange(e){
                this.pager.pageIndex = e;
            },
            handleSearch() {
                let vm = this;
                this.$http.post(this.api.list,this.$qs.stringify(this.searchParams)).then((resp)=>{


                    for(let key in resp.data.data){
                        if(resp.data.data[key] instanceof Array){
                            vm.tableData = resp.data.data[key];
                        }
                    }

                    //处理分页
                    vm.pager.pageIndex = resp.data.data.pager.pageIndex;
                    vm.pager.pageSize = resp.data.data.pager.pageSize;
                    vm.pager.itemCount = resp.data.data.pager.itemCount;

                })
            }
        },
        async created() {
            for (let key in this.searchForm){
                 if(this.$route.query[key]){
                     this.searchForm[key]= this.$route.query[key];
                 }
            }

           let res = await this.$http.post(this.$api.deviceStat.statCount);
            this.count = res.data.data;
        }
    }
</script>

<style scoped>
.space-list{
    display: flex;
    justify-content: flex-start;
}
.space-item{
    padding: 12px 24px;
    background-color: #d5d5d6;
    margin-right:12px;
    font-size: 18px;
}

    .label{
        font-size: 12px;
        margin-top: 12px;
    }


</style>